export default __webpack_public_path__ + "static/media/sunset-lajolla.b3bb27b4.jpg";